export default "__VITE_ASSET__DHa$zi9x__"